import React, { useState } from "react";
import classes from "./Alert.module.scss";

const Alert = ({
  text = null,
  icon = null,
  label_1 = null,
  label_2 = null,
  onClick = () => {},
  alertType = "info",
  mt = "",
  noMargin = null,
  closeBtn = true,
  className = null,
}) => {
  const [show, setShow] = useState(true);
  let alert = null;
  let styles = {};
  if (noMargin) styles = { margin: 0 };
  if (text && text !== "" && show) {
    let finalClass = classes.Info;
    if (alertType === "success") finalClass = classes.Success;
    if (alertType === "warning") finalClass = classes.Warning;
    if (alertType === "danger") finalClass = classes.Danger;
    if (alertType === "wait") finalClass = classes.Wait;
    if (mt) finalClass += " " + classes.Mt;
    if (className) finalClass += " " + className;
    alert = (
      <div
        className={classes.Alert + " " + finalClass}
        role="alert"
        style={{ ...styles }}
      >
        {text}
        {closeBtn && (
          <button
            type="button"
            className={classes.Close}
            onClick={() => setShow(false)}
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        )}
      </div>
    );
  }
  if (icon && icon !== "" && show) {
    let finalClass = classes.Info;
    if (alertType === "wait") finalClass = classes.Wait;
    alert = (
      <div
        className={classes.Alert + " " + finalClass}
        role="alert"
        style={{ ...styles }}
      >
        {icon && (
          <>
            <div className={classes.FirstDiv}>{icon}</div>
            <div className={classes.SecondDiv}>
           
              <div className="row align-items-center h-100">
                <div className="col-12">{label_1}</div>
                {label_2? <div className="col-12">{label_2}</div> : null}
               
              </div>
             
            </div>
          </>
        )}
      </div>
    );
  }
  return alert;
};

export default Alert;
